import { Component } from "react";
function isRenderer(fallback) {
    return typeof fallback === "function";
}
class ErrorHandler extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: undefined
        };
        this.retry = () => {
            return this.setState({ error: undefined });
        };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        if (error instanceof Error) {
            return { error };
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        const props = this.props;
        const keys = new Set([...Object.keys(props), ...Object.keys(prevProps)]);
        for (const key of keys) {
            if (key === "fallback" || key === "children")
                continue;
            if (props[key] !==
                prevProps[key]) {
                this.retry();
                break;
            }
        }
    }
    componentDidCatch(error, info) {
        if (!(error instanceof Error)) {
            throw error;
        }
        // Log the error to an error reporting service
        // logErrorToMyService(error, info);
    }
    render() {
        const { fallback, children } = this.props;
        const { error } = this.state;
        if (error) {
            if (isRenderer(fallback)) {
                return fallback(error, this.retry);
            }
            return fallback;
        }
        return children;
    }
}
ErrorHandler.defaultProps = {
    fallback: error => error.message
};
export { ErrorHandler };
//# sourceMappingURL=ErrorHandler.js.map